<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
      >
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="timeClocks"
        >
          <template v-slot:item.created_at="{ item }">
            {{ $moment(item.created_at).format('D MMMM YYYY') }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      isProfileTab: {
        type: Boolean,
      },
    },

    data () {
      return {
        loading: true,
        timeClocks: [],
        headers: [
          {
            text: 'Date',
            value: 'created_at',
          },
          {
            text: 'Time Out',
            value: 'time_out',
          },
          {
            text: 'Time In',
            value: 'time_in',
          },
          {
            text: 'Total Time',
            value: 'difference',
          },

        ],
      }
    },

    mounted () {       
      this.loadData()
    },

    methods: {
      loadData () {
        this.$api.timeClocks().list(this.employeeUid)
          .then(response => {
            response.data.map(item => {
              let endTime = this.$moment(this.$moment(item.created_at).format('YYYY-MM-DD') + ' ' + item.time_in)
              let startTime = this.$moment(this.$moment(item.created_at).format('YYYY-MM-DD') + ' ' + item.time_out)
             
              let hour = this.$moment.duration(endTime.diff(startTime)).as('minutes') / 60
              let minutes = (hour - Math.floor(hour)) * 60
            
              if (!isNaN(hour) && !isNaN(minutes)) {
                item.difference = Math.floor(hour) + ' Hours ' + Math.floor(minutes) + ' Minutes' 
              }
            })

            this.timeClocks = response.data
            this.loading = false
          })
      },

    },
  }
</script>
